import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_-domain_active",
  "use": "sort_-domain_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_-domain_active\"><path fill-rule=\"evenodd\" d=\"M2 4.007C2 3.45 2.445 3 3 3h14c.552 0 1 .45 1 1.007v11.986C18 16.55 17.555 17 17 17H3c-.552 0-1-.45-1-1.007V4.007ZM2 8h16v1H2V8Zm2-3h1v1H4V5Zm2 0h1v1H6V5Zm2 0h1v1H8V5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol